import { useMobileContext } from '@shared';
import { Flex, Heading, Button, Image, Card, Text } from '@chakra-ui/react';
import { tavoittajaLogo } from '@shared';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export function ErrorFallback({ error }: { error?: string }) {
	const { t } = useTranslation();
	const { isMobile } = useMobileContext();
	const navigate = useNavigate();

	return (
		<Flex height="100%" flexDirection="column" justifyContent="center" alignItems="center" padding={2} backgroundColor={'rgba(251, 249, 255, 1)'}>
			<Card.Root borderRadius={'12px'}>
				<Card.Body padding={0} overflow="hidden" backgroundColor="white" borderRadius={'12px'}>
					<Flex>
						{!isMobile ? (
							<Flex backgroundColor="rgb(61, 213, 152)" flexDirection={'column'} alignItems={'center'} justifyContent={'center'} padding={4}>
								<Image height={'60%'} objectFit="contain" padding={2} paddingLeft={7} paddingRight={7} src={tavoittajaLogo}></Image>
								<Heading marginBottom={2} color="white">
									Tavoittaja
								</Heading>
							</Flex>
						) : null}
						<Flex alignItems={'center'} gap={4} padding={4} paddingLeft={10} paddingRight={10} minWidth={'70%'} maxW={'100vw'}>
							<Flex flexDirection="column" maxW={'100%'}>
								<Heading marginBottom={4}>{t('general.oops_something_went_wrong')}</Heading>
								<Text>{error || t('general.unexpected_error')}</Text>
								<Text> {t('general.we_are_informed')}</Text>

								<Flex gap={2} flexWrap={'wrap'}>
									<Button marginTop={4} onClick={() => navigate(-1)}>
										{t('general.go_back_to_previous_page')}
									</Button>
									<Button
										marginTop={4}
										onClick={() => {
											window.location.reload();
										}}
									>
										{t('general.reload_page')}
									</Button>
								</Flex>
							</Flex>
						</Flex>
					</Flex>
				</Card.Body>
			</Card.Root>
		</Flex>
	);
}
